Ext.define('SA.EditPanelDisabledItem', {
    alias: 'widget.edit-panel-disabled-item',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-panel-disabled-item',

    initComponent() {
        this.items = [{
            xtype: 'component',
            itemId: 'labelCmp',
            cls: 'sa-edit-panel-disabled-item-label',
            html: this.getLabelHtml()
        }];

        this.callParent();

        this.labelCmp = this.down('#labelCmp');
    },

    getDataId() {
        return this.dataId;
    },

    getLabelHtml() {
        var label = this.labelFactory.create(this.getDataId());

        return this.labelFactory.isHtml() ? label : Ext.String.htmlEncode(label);
    },

    refreshLabel() {
        this.labelCmp.update(this.getLabelHtml());
    }
});